module.exports = __webpack_public_path__ + "@/assets/img/20.645f5d5c.jpg";